import { graphql, useStaticQuery } from 'gatsby';

export function getAllPromotions() {
  const data = useStaticQuery(graphql`
    query {
      umbraco {
        allDswPromotionPage(orderBy: startDate_ASC) {
          items {
            title
            subtitle
            description
            featuredImage {
              url
            }
            price
            startDate
            endDate
            discount
            discountLabel
            currency
            bookingLink {
              url
              name
              target
            }
          }
        }
      }
    }
  `);

  return data.umbraco.allDswPromotionPage.items || [];
}
